import React from 'react';
import { X } from 'lucide-react';

interface TabHeaderProps {
  title: string;
  icon?: React.ReactNode;
  onClose?: () => void;
}

export function TabHeader({ title, icon, onClose }: TabHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {icon && (
          <div className="relative">
            {icon}
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
          </div>
        )}
        <h2 className="text-xl font-semibold">{title}</h2>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
      )}
    </div>
  );
}